import { Link } from "react-router-dom";

export default function CtaBand() {
  return (
    <section className="max-w-portal mx-auto px-4 md:px-6 pt-12 md:pt-16">
      <div className="relative overflow-hidden rounded-lg bg-foreground-950 px-6 py-10 md:px-12 md:py-14">
        <div className="absolute -right-10 -top-10 w-48 h-48 rounded-full bg-accent-500/20 blur-2xl" aria-hidden="true" />
        <div className="relative flex flex-col lg:flex-row lg:items-center gap-6 lg:gap-10">
          <div className="flex-1">
            <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.2em] text-primary-400 uppercase">
              <i className="ri-megaphone-line w-4 h-4 flex items-center justify-center" />
              Submit A Lead
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-black text-background-50 mt-3">
              你手里也有镜头之外的故事？
            </h2>
            <p className="text-sm md:text-base text-background-300 leading-relaxed mt-3 max-w-2xl">
              欢迎分享你经历或了解到的综艺、影视、剧组幕后线索。我们会与你逐条确认可公开的范围，
              再决定以什么角度呈现。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <Link
              to="/about#contact"
              className="inline-flex items-center justify-center gap-1.5 px-6 py-3 rounded-md bg-primary-500 text-foreground-950 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-primary-400 transition-colors"
            >
              <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center" />
              提交爆料线索
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-1.5 px-6 py-3 rounded-md border border-background-600 text-background-100 text-sm font-bold whitespace-nowrap cursor-pointer hover:bg-background-800 transition-colors"
            >
              了解内容原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}